import React from "react";
import { Link } from "react-router-dom";
import StarRatingComponent from "react-star-rating-component";
import { connect } from "react-redux";
// import { this.props.history } from "react-router";
import { bindActionCreators } from "redux";
import * as specialistActions from "../../actions/specialistActions.js";
import ConsultationAddress from "../appointment/consultationAddress.js";
import * as constant from "../../constants/constant";
import { Typeahead } from "react-bootstrap-typeahead";
import Pagination from "react-js-pagination";
import Moment from "react-moment";
import "react-bootstrap-typeahead/css/Typeahead.css";
import $ from "jquery";
import * as dashboardActions from "../../actions/dashboardActions";
import {
	confirmAlert
} from 'react-confirm-alert';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment-timezone'
import Autocomplete from 'react-google-autocomplete';

const size = 10;
let btnSize = { fontSize: 13 };
let fee1Status, fee2Status, fee3Status;
class SpecialistDetails extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			isLoader: true,
			specialistDetails: {},
			schedule: {},
			//other consultation
			openModal: false,
			otherConsultationAddress: [],
			presentConsultationId: "",

			specializationList: [],
			specialization: "",
			searchGender: "",
			activePage: 1,
			count: size,
			totalCount: size,
			myFeedback: [],
			questionRatings: [],
			specializationName: "",
			mondayMornStartHrs: "8",
			mondayMornStartMin: "00",
			mondayMornEndHrs: "10",
			mondayMornEndMin: "00",

			mondayEvenStartHrs: "16",
			mondayEvenStartMin: "00",
			mondayEvenEndHrs: "22",
			mondayEvenEndMin: "00",

			tuesdayMornStartHrs: "8",
			tuesdayMornStartMin: "00",
			tuesdayMornEndHrs: "10",
			tuesdayMornEndMin: "00",

			tuesdayEvenStartHrs: "17",
			tuesdayEvenStartMin: "00",
			tuesdayEvenEndHrs: "22",
			tuesdayEvenEndMin: "00",

			wednesdayMornStartHrs: "8",
			wednesdayMornStartMin: "00",
			wednesdayMornEndHrs: "10",
			wednesdayMornEndMin: "00",

			wednesdayEvenStartHrs: "17",
			wednesdayEvenStartMin: "00",
			wednesdayEvenEndHrs: "22",
			wednesdayEvenEndMin: "00",

			thursdayMornStartHrs: "8",
			thursdayMornStartMin: "00",
			thursdayMornEndHrs: "10",
			thursdayMornEndMin: "00",

			thursdayEvenStartHrs: "17",
			thursdayEvenStartMin: "00",
			thursdayEvenEndHrs: "22",
			thursdayEvenEndMin: "00",

			fridayMornStartHrs: "8",
			fridayMornStartMin: "00",
			fridayMornEndHrs: "10",
			fridayMornEndMin: "00",

			fridayEvenStartHrs: "17",
			fridayEvenStartMin: "00",
			fridayEvenEndHrs: "22",
			fridayEvenEndMin: "00",

			saturdayMornStartHrs: "8",
			saturdayMornStartMin: "00",
			saturdayMornEndHrs: "10",
			saturdayMornEndMin: "00",

			saturdayEvenStartHrs: "17",
			saturdayEvenStartMin: "00",
			saturdayEvenEndHrs: "22",
			saturdayEvenEndMin: "00",
			localCurrency: null,

			sundayMornStartHrs: "8",
			sundayMornStartMin: "00",
			sundayMornEndHrs: "10",
			sundayMornEndMin: "00",

			sundayEvenStartHrs: "17",
			sundayEvenStartMin: "00",
			sundayEvenEndHrs: "22",
			sundayEvenEndMin: "00",
			filterColapsableDistance: true,
			filterColapsablePatientReviews: true,
			filterColapsableAvailability: true,
			filterColapsableConsultationfees: true,
			filterColapsableGender: true,
			rebbon: false,
			otherMilesDistance: [],


			mondayMinTime: '',
			mondayMoutTime: '',
			mondayEinTime: '',
			mondayEoutTime: '',
			tuesdayMinTime: '',
			tuesdayMoutTime: '',
			tuesdayEinTime: '',
			tuesdayEoutTime: '',
			wednesdayMinTime: '',
			wednesdayMoutTime: '',
			wednesdayEinTime: '',
			wednesdayEoutTime: '',
			thursdayMinTime: '',
			thursdayMoutTime: '',
			thursdayEinTime: '',
			thursdayEoutTime: '',
			fridayMinTime: '',
			fridayMoutTime: '',
			fridayEinTime: '',
			fridayEoutTime: '',
			saturdayMinTime: '',
			saturdayMoutTime: '',
			saturdayEinTime: '',
			saturdayEoutTime: '',
			sundayMinTime: '',
			sundayMoutTime: '',
			sundayEinTime: '',
			sundayEoutTime: '',
			userlocation: ''


		};
		this.goToCalendarPage = this.goToCalendarPage.bind(this);
		this.openConsultationModal = this.openConsultationModal.bind(this);
		this.hideConsultationModal = this.hideConsultationModal.bind(this);
		this.getOtherConsultationAddress = this.getOtherConsultationAddress.bind(
			this
		);
		this.goToCalendarPageFromOtherConsulatation = this.goToCalendarPageFromOtherConsulatation.bind(
			this
		);

		this.search = this.search.bind(this);
		this.onChangeSelect = this.onChangeSelect.bind(this);
		this.onChange = this.onChange.bind(this);
		this.onNarrowChange = this.onNarrowChange.bind(this);
		this.showAddressPopUp = this.showAddressPopUp.bind(this);
		this.hideAddressPopUp = this.hideAddressPopUp.bind(this);
		this.handlePageChange = this.handlePageChange.bind(this);
		this.rebbonClick = this.rebbonClick.bind(this);
		this.filterColapsableClickedDistance = this.filterColapsableClickedDistance.bind(
			this
		);
		this.filterColapsableClickedPatientReviews = this.filterColapsableClickedPatientReviews.bind(
			this
		);
		this.filterColapsableClickedAvailability = this.filterColapsableClickedAvailability.bind(
			this
		);
		this.filterColapsableClickedConsultationfees = this.filterColapsableClickedConsultationfees.bind(
			this
		);
		this.filterColapsableClickedGender = this.filterColapsableClickedGender.bind(
			this
		);
		this.currencyApi = this.currencyApi.bind(this);
		this._logout = this._logout.bind(this)
		this.rebbonClick = this.rebbonClick.bind(this);
		this.reviewCount = this.reviewCount.bind(this);
		this.updateAddress = this.updateAddress.bind(this);

	}
	updateAddress(address) {
		let self = this;
		var placeSearch, autocomplete;
		var componentForm = {
			street_number: 'Street Number',
			route: 'Route',
			postal_town: 'Town',
			locality: 'locality',
			administrative_area_level_1: 'State ',
			country: 'country',
			postal_code: 'Zip Code'
		};

		for (var i = 0; i < address.address_components.length; i++) {
			var addressType = address.address_components[i].types[0];
			if (componentForm[addressType]) {
				let val = address.address_components[i][componentForm[addressType]];
				componentForm[addressType] = address.address_components[i].long_name;
			}

		}
		var zip = componentForm.postal_code != 'Zip Code' ? componentForm.postal_code + ' ,' : ''
		var town = componentForm.postal_town != 'Town' ? componentForm.postal_town : componentForm.locality != 'locality' ? componentForm.locality + ',' : ''
		var country = componentForm.country != 'country' ? componentForm.country : ''
		country = country.toLowerCase()
			.split(' ')
			.map((s) => s.charAt(0).toUpperCase() + s.substring(1))
			.join(' ');
		self.setState({
			searchZipcode: zip + town + country
		})
	}
	reviewCount() {
		this.setState({ reviewCountClicked: !this.state.reviewCountClicked })
	}
	rebbonClick(index, e) {
		if (index == 'close') {
			this.setState({ rebbon: false })
		}
		else {
			this.setState({ rebbon: "RebbonPopup" + index })
		}
	}
	_logout(event) {
		let userId = localStorage.getItem('userId')
		this.props.logoutAction.logout({ 'userId': userId })
		event.preventDefault();
		localStorage.clear();
		this.props.history.push('/');
	}
	currencyApi(from, amt) {
		let data = {
			base: from,
			amount: amt
		}
		console.log("===>>", from, amt)
		if (from != localStorage.getItem('currency') && localStorage.getItem('currency')) {
			console.log("currenctyy has beenconverted ddddddd==>>", localStorage.getItem('currency'))
			this.props.actions.currencychange(data);
		}
		else if (from == localStorage.getItem('currency')) {
			console.log("same currency===")
		}
		else {
			console.log("same currency===error")
			toast.info('Plese turn on the Location');
		}
	}
	filterColapsableClickedDistance() {
		this.setState({
			filterColapsableDistance: !this.state.filterColapsableDistance
		});
	}

	filterColapsableClickedPatientReviews() {
		this.setState({
			filterColapsablePatientReviews: !this.state.filterColapsablePatientReviews
		});
	}

	filterColapsableClickedAvailability() {
		this.setState({
			filterColapsableAvailability: !this.state.filterColapsableAvailability
		});
	}

	filterColapsableClickedConsultationfees() {
		this.setState({
			filterColapsableConsultationfees: !this.state
				.filterColapsableConsultationfees
		});
	}

	filterColapsableClickedGender() {
		this.setState({
			filterColapsableGender: !this.state.filterColapsableGender
		});
	}
	handlePageChange(pageNumber) {
		this.setState({ activePage: pageNumber });
		var obj = {
			doctorId: localStorage.getItem("specialistId"),
			count: this.state.count,
			page: pageNumber
		};
		this.props.actions.getMyFeedback(obj);
	}

	hideAddressPopUp() {
		document.getElementById("addressPopUp").style.display = "none";
	}
	showAddressPopUp(doctorId, availId) {
		let obj = {
			doctorId: doctorId,
			isPrimaryAddress: false,
			latitude: parseFloat(localStorage.getItem('lat')),
			longitude: parseFloat(localStorage.getItem('lng')),
			searchZipcode: this.state.searchZipcode,

		};
		this.props.actions.getOtherConsultationAddress(obj);
		document.getElementById("addressPopUp").style.display = "block";
	}
	onChangeSelect(event) {
		// var selectedValue = this.state.specializationList[event.target.value]
		this.setState({
			isReady: true,
			// specializationName: selectedValue.specialization,
			specialization: event.target.value
		});
	}
	onChange(event) {
		this.setState({
			isReady: true,
			[event.target.name]: event.target.value
		});
	}
	onNarrowChange() {
		if (this.state.specialization) {
			localStorage.setItem("specializationId", this.state.specialization);
			localStorage.setItem("specializationName", this.state.specializationName);
		}
		if (this.state.searchZipcode) {
			localStorage.setItem("zipcode", this.state.searchZipcode);
		}
		localStorage.setItem("gender", this.state.searchGender);
		localStorage.setItem("mileDistance", this.state.searchMileDistance);

		localStorage.setItem("fee1", this.state.fee1);
		localStorage.setItem("fee2", this.state.fee2);
		localStorage.setItem("fee3", this.state.fee3);

		var state = this.state;
		var array = [1, 1, 1, 1, 1];
		var str = "";
		array.forEach(function (item, index) {
			if (state["rate" + index] == "true") {
				str = str + index + ",";
				localStorage.setItem("rateValue", str);
			}
		});
		this.props.history.push("/book-appointment");
	}
	search() {
		if (
			this.state.specialization != undefined ||
			this.state.searchZipcode != undefined
		) {
			this.setState({
				isSearch: true,
				narrowFilter: true
			});
			if (this.state.searchZipcode != "") {
				this.setState({ narrowFilterZipCode: true });
			}

			// console.log("this.state.specialization", this.state.specialization);
			localStorage.setItem("zipcode", this.state.searchZipcode);
			localStorage.setItem("specializationId", this.state.specialization);
			localStorage.setItem("specializationName", this.state.specializationName);
			this.props.history.push("/dashboard/book-appointment");
		} else {
			toast.warning("Please select specialization or enter zipcode");
		}
	}
	getOtherConsultationAddress(doctorId, availId) {
		let obj = {
			doctorId: doctorId,
			isPrimaryAddress: false,
			latitude: parseFloat(localStorage.getItem('lat')),
			longitude: parseFloat(localStorage.getItem('lng')),
			searchZipcode: this.state.searchZipcode,
		};
		this.props.actions.getOtherConsultationAddress(obj);
		this.openConsultationModal(availId);
	}
	openConsultationModal(availId) {
		var state = this.state;
		state.openModal = true;
		state.presentConsultationId = availId;
		this.setState(state);
	}
	hideConsultationModal() {
		var state = this.state;
		state.openModal = false;
		this.setState(state);
	}

	Capitalize(str) {
		if (str != "" && str != undefined)
			return str.charAt(0).toUpperCase() + str.slice(1);
		else return "";
	}

	goToCalendarPageFromOtherConsulatation(availId, index) {
		localStorage.availabilityId = availId;
		let specialistData = this.state.otherConsultationAddress[index].data;
		console.log("SPECIALIST DATA", specialistData)
		// localStorage.availabilityId = specialistData.avId;
		localStorage.clinicCountryZone = specialistData.contryzone;
		localStorage.setItem('clinicCountryZone', specialistData.contryzone);
		localStorage.setItem('doctorAddress', specialistData.addressLineOne + ', ' + specialistData.city + ', ' + specialistData.country)

		localStorage.availabilityId = availId;
		this.props.history.push("/dashboard/book-appointment-calendar");
	}

	goToCalendarPage() {

		this.props.history.push("/dashboard/book-appointment-calendar");
	}

	componentWillMount() {
		this.props.actions.getSpecializationList();
		let data = {
			doctorId: localStorage.getItem('specialistId') ? localStorage.getItem('specialistId') : this.state.specialistId,
		}
		this.props.actions.getAvgRatingByQuestions(data);

		// moment("2013-11-18").tz("Europe/Berlin").format('Z');

		localStorage.setItem("availabilityId", this.props.match.params.availabilityId);
		var state = this.state;
		state.userlocation = moment(new Date()).tz(moment.tz.guess()).format('z');
		console.log('==========================', state.userlocation);
		state.specialization =
			state.specialization && state.specialization != ""
				? state.specialization
				: localStorage.getItem("specializationId");

		state.specializationName =
			state.specializationName && state.specializationName != ""
				? state.specializationName
				: localStorage.getItem("specializationName");

		this.setState(state);

		let availabilityId = this.props.match.params.availabilityId;
		let appointmentObj = {
			availabilityId: availabilityId,
			userTimezone: moment.tz.guess()
		};
		this.props.actions.getSpecialistDetails(appointmentObj);
		var obj = {
			doctorId: localStorage.getItem("specialistId")
				? localStorage.getItem("specialistId")
				: this.state.specialistId,
			count: this.state.count,
			page: this.state.activePage
		};
		this.props.actions.getMyFeedback(obj);
	}
	componentDidMount() {
		var state = this.state;

		state.searchZipcode =
			state.searchZipcode && state.searchZipcode != ""
				? state.searchZipcode
				: localStorage.getItem("zipcode");
		state.searchMileDistance =
			state.searchMileDistance && state.searchMileDistance != ""
				? state.searchMileDistance
				: localStorage.getItem("mileDistance");
		state.specialistId = localStorage.getItem("specialistId");
		state.searchGender =
			state.searchGender && state.searchGender != ""
				? state.searchGender
				: localStorage.getItem("gender");
		var rateArray = [];

		// console.log("localStorage.getItem('rateValue') && (localStorage.getItem('rateValue') != null || localStorage.getItem('rateValue') != '')", localStorage.getItem('rateValue') && (localStorage.getItem('rateValue') != null || localStorage.getItem('rateValue') != ''));

		if (
			localStorage.getItem("rateValue") &&
			(localStorage.getItem("rateValue") != null ||
				localStorage.getItem("rateValue") != "")
		) {
			var ratevalue = localStorage.getItem("rateValue");
			rateArray = ratevalue
				.split(",")
				.map(Number)
				.filter(Number);
			rateArray.forEach(function (value, index) {
				if (value == 1) {
					state.rate1 = "true";
				} else if (value == 2) {
					state.rate2 = "true";
				} else if (value == 3) {
					state.rate3 = "true";
				} else if (value == 4) {
					state.rate4 = "true";
				} else if (value == 5) {
					state.rate4 = "true";
				}
			});
		}

		state.fee1 =
			state.fee1 && state.fee1 != ""
				? state.fee1
				: localStorage.getItem("fee1");
		state.fee2 =
			state.fee2 && state.fee2 != ""
				? state.fee2
				: localStorage.getItem("fee2");
		state.fee3 =
			state.fee3 && state.fee3 != ""
				? state.fee3
				: localStorage.getItem("fee3");

		if (
			localStorage.getItem("specializationId") &&
			localStorage.getItem("specializationId") != ""
		) {
			state.specializationName = localStorage.getItem("specializationName");
			state.specializationId = localStorage.getItem("specializationId");
		}

		this.setState(state);

		console.log("this.state", this.state);

		// localStorage.setItem("specializationId", "");
		// localStorage.setItem("specializationName", "");

		// localStorage.setItem("zipcode", "");
		// localStorage.setItem("mileDistance", 0);
		localStorage.setItem("fee1", "");
		localStorage.setItem("fee2", "");
		localStorage.setItem("fee3", "");
		localStorage.setItem("gender", "");
		localStorage.setItem("rateValue", "");

	}
	// rebbonClick() {

	// 	this.setState({ rebbon: !this.state.rebbon })
	// }
	componentWillReceiveProps(nextProps) {
		console.log("Specialist Details", nextProps)
		let currancy = nextProps.convertedCurrency ? parseFloat(nextProps.convertedCurrency.result).toFixed(2) : '';
		if (currancy) {
			confirmAlert({
				customUI: ({ onClose }) => {
					return (
						<div className='custom-ui'>
							<a style={{ cursor: "pointer" }} className="closeBtn" onClick={onClose}></a>

							<h1>Currency Exchange Rate</h1>
							<p> {nextProps.convertedCurrency.query.amount} {nextProps.convertedCurrency.query.from} = {currancy} {localStorage.getItem('currency')}</p>
							<span>The exchange rate is just for reference and is an estimate.The actual amount charged will be dependent on the payment gateway and the exchange rate used by them at the point of payment</span>

						</div>
					)
				}
			})
		}
		var state = this.state;
		if (nextProps.specialistDetails && nextProps.specialistDetails.specialists) {
			state.specialistDetails = nextProps.specialistDetails;
		}
		state.localCurrency = nextProps.convertedCurrency ? '≈ ' + currancy + ' ' + localStorage.getItem('currency') : '',

			state.isLoader = false;
		state.specializationList =
			nextProps.specializationList && nextProps.specializationList.length > 0
				? nextProps.specializationList
				: state.specializationList;

		state.otherConsultationAddress = nextProps.otherConsultationAddress ? nextProps.otherConsultationAddress.specialistRecord : state.otherConsultationAddress;
		state.otherMilesDistance = nextProps.otherConsultationAddress ? nextProps.otherConsultationAddress.arraymiles : state.otherMilesDistance;
		state.questionRatings = (nextProps.questionRatings && nextProps.questionRatings.avgQuttionsRating.length > 0) ? nextProps.questionRatings.avgQuttionsRating : []

		state.myFeedback =
			nextProps.myFeedback &&
				nextProps.myFeedback.ratingDetails &&
				nextProps.myFeedback.ratingDetails.length > 0
				? nextProps.myFeedback.ratingDetails
				: [];
		state.totalCount =
			nextProps.myFeedback && nextProps.myFeedback.totalCount
				? nextProps.myFeedback.totalCount
				: 0;
		if (nextProps.schedule != undefined) {
			state.schedule = nextProps.schedule;
		}
		if (
			nextProps.schedule != undefined &&
			nextProps.schedule.hasOwnProperty("mondayMorningSchedule") &&
			nextProps.schedule.monday == true
		) {
			if (nextProps.schedule && nextProps.schedule.mondayMorningSchedule) {
				state.mondayMornStartHrs =
					nextProps.schedule.mondayMorningSchedule &&
						nextProps.schedule.mondayMorningSchedule.startHour
						? nextProps.schedule.mondayMorningSchedule.startHour
						: state.mondayMornStartHrs;

				state.mondayMornEndHrs =
					nextProps.schedule.mondayMorningSchedule &&
						nextProps.schedule.mondayMorningSchedule.endHour
						? nextProps.schedule.mondayMorningSchedule.endHour
						: state.mondayMornEndHrs;

				state.mondayMinTime = nextProps.schedule != undefined && nextProps.schedule && nextProps.schedule.mondayUtcMorningSchedule != undefined ? nextProps.schedule.mondayUtcMorningSchedule.inTime : ''
				state.mondayMoutTime = nextProps.schedule.mondayUtcMorningSchedule != undefined ? nextProps.schedule.mondayUtcMorningSchedule.outTime : ""

				state.mondayEinTime = nextProps.schedule.mondayUtcEveningSchedule != undefined ? nextProps.schedule.mondayUtcEveningSchedule.inTime : ''
				state.mondayEoutTime = nextProps.schedule.mondayUtcEveningSchedule != undefined ? nextProps.schedule.mondayUtcEveningSchedule.outTime : ""


				if (
					nextProps.schedule.mondayMorningSchedule &&
					nextProps.schedule.mondayMorningSchedule.startMinute
				) {
					state.mondayMornStartMin =
						nextProps.schedule.mondayMorningSchedule.startMinute == "0"
							? "00"
							: state.mondayMornStartMin;

				}
				if (
					nextProps.schedule.mondayMorningSchedule &&
					nextProps.schedule.mondayMorningSchedule.startMinute
				) {
					state.mondayMornEndMin =
						nextProps.schedule.mondayMorningSchedule.startMinute == "0"
							? "00"
							: nextProps.schedule.mondayMorningSchedule.startMinute;
					state.mondayMinTime = nextProps.schedule != undefined && nextProps.schedule && nextProps.schedule.mondayUtcMorningSchedule != undefined ? nextProps.schedule.mondayUtcMorningSchedule.inTime : ''
					state.mondayMoutTime = nextProps.schedule.mondayUtcMorningSchedule != undefined ? nextProps.schedule.mondayUtcMorningSchedule.outTime : ""

					state.mondayEinTime = nextProps.schedule.mondayUtcEveningSchedule != undefined ? nextProps.schedule.mondayUtcEveningSchedule.inTime : ''
					state.mondayEoutTime = nextProps.schedule.mondayUtcEveningSchedule != undefined ? nextProps.schedule.mondayUtcEveningSchedule.outTime : ""

				}
			}
			// Monday Evening
			if (nextProps.schedule != undefined && nextProps.schedule.mondayEveningSchedule) {
				state.mondayEvenStartHrs =
					nextProps.schedule.mondayEveningSchedule &&
						nextProps.schedule.mondayEveningSchedule.startHour
						? nextProps.schedule.mondayEveningSchedule.startHour
						: state.mondayEvenStartHrs;

				state.mondayEvenEndHrs =
					nextProps.schedule.mondayEveningSchedule &&
						nextProps.schedule.mondayEveningSchedule.endHour
						? nextProps.schedule.mondayEveningSchedule.endHour
						: state.mondayEvenEndHrs;

				if (
					nextProps.schedule.mondayEveningSchedule &&
					nextProps.schedule.mondayEveningSchedule.startMinute
				) {
					state.mondayEvenStartMin =
						nextProps.schedule.mondayEveningSchedule.startMinute == "0"
							? "00"
							: state.mondayEvenStartMin;
				}

				if (
					nextProps.schedule.mondayMorningSchedule &&
					nextProps.schedule.mondayMorningSchedule.startMinute
				) {
					state.mondayEvenStartMin =
						nextProps.schedule.mondayMorningSchedule.startMinute == "0"
							? "00"
							: nextProps.schedule.mondayMorningSchedule.startMinute;
				}
			}
		}
		// Tuesday Morning
		if (
			nextProps.schedule != undefined &&
			nextProps.schedule.hasOwnProperty("tuesdayMorningSchedule") &&
			nextProps.schedule.tuesday == true
		) {
			if (nextProps.schedule && nextProps.schedule.tuesdayMorningSchedule) {
				state.tuesdayMornStartHrs =
					nextProps.schedule.tuesdayMorningSchedule &&
						nextProps.schedule.tuesdayMorningSchedule.startHour
						? nextProps.schedule.tuesdayMorningSchedule.startHour
						: state.tuesdayMornStartHrs;

				state.tuesdayMinTime = nextProps.schedule.tuesdayUtcMorningSchedule != undefined ? nextProps.schedule.tuesdayUtcMorningSchedule.inTime : ''
				state.tuesdayMoutTime = nextProps.schedule.tuesdayUtcMorningSchedule != undefined ? nextProps.schedule.tuesdayUtcMorningSchedule.outTime : ""

				state.tuesdayEinTime = nextProps.schedule.tuesdayUtcEveningSchedule != undefined ? nextProps.schedule.tuesdayUtcEveningSchedule.inTime : ''
				state.tuesdayEoutTime = nextProps.schedule.tuesdayUtcEveningSchedule != undefined ? nextProps.schedule.tuesdayUtcEveningSchedule.outTime : ""

				if (
					nextProps.schedule.tuesdayMorningSchedule &&
					nextProps.schedule.tuesdayMorningSchedule.startMinute
				) {
					state.tuesdayMornStartMin =
						nextProps.schedule.tuesdayMorningSchedule.startMinute == "0"
							? "00"
							: state.tuesdayMornStartMin;


				}

				state.tuesdayMornEndHrs =
					nextProps.schedule.tuesdayMorningSchedule &&
						nextProps.schedule.tuesdayMorningSchedule.endHour
						? nextProps.schedule.tuesdayMorningSchedule.endHour
						: state.tuesdayMornEndHrs;

				if (
					nextProps.schedule.EveningSchedule &&
					nextProps.schedule.EveningSchedule.startMinute
				) {
					state.tuesdayMornEndMin =
						nextProps.schedule.EveningSchedule.startMinute == "0"
							? "00"
							: nextProps.schedule.EveningSchedule.startMinute;
				}
			}
		}
		// Tuestay Evening
		if (
			nextProps.schedule != undefined &&
			nextProps.schedule.hasOwnProperty("tuesdayEveningSchedule") &&
			nextProps.schedule.tuesday == true
		) {
			if (nextProps.schedule != undefined && nextProps.schedule.tuesdayEveningSchedule) {
				state.tuesdayEvenStartHrs =
					nextProps.schedule.tuesdayEveningSchedule &&
						nextProps.schedule.tuesdayEveningSchedule.startHour
						? nextProps.schedule.tuesdayEveningSchedule.startHour
						: state.tuesdayEvenStartHrs;

				if (
					nextProps.schedule.tuesdayEveningSchedule &&
					nextProps.schedule.tuesdayEveningSchedule.startMinute
				) {
					state.tuesdayEvenStartMin =
						nextProps.schedule.tuesdayEveningSchedule.startMinute == "0"
							? "00"
							: state.tuesdayEveningSchedule;
				}

				state.tuesdayEvenEndHrs =
					nextProps.schedule.tuesdayEveningSchedule &&
						nextProps.schedule.tuesdayEveningSchedule.endHour
						? nextProps.schedule.tuesdayEveningSchedule.endHour
						: state.tuesdayEvenEndHrs;

				if (
					nextProps.schedule.tuesdayEveningSchedule &&
					nextProps.schedule.tuesdayEveningSchedule.startMinute
				) {
					state.tuesdayEvenEndMin =
						nextProps.schedule.tuesdayEveningSchedule.startMinute == "0"
							? "00"
							: nextProps.schedule.tuesdayEveningSchedule.startMinute;
				}
			}
		}



		// Wednesday Morning
		if (
			nextProps.schedule != undefined &&
			nextProps.schedule.hasOwnProperty("wednesdayMorningSchedule") &&
			nextProps.schedule.wednesday == true
		) {
			if (nextProps.schedule && nextProps.schedule.wednesdayMorningSchedule) {
				state.wednesdayMornStartHrs =
					nextProps.schedule.wednesdayMorningSchedule &&
						nextProps.schedule.wednesdayMorningSchedule.startHour
						? nextProps.schedule.wednesdayMorningSchedule.startHour
						: state.wednesdayMornStartHrs;

				state.wednesdayMinTime = nextProps.schedule.wednesdayUtcMorningSchedule != undefined ? nextProps.schedule.wednesdayUtcMorningSchedule.inTime : ''
				state.wednesdayMoutTime = nextProps.schedule.wednesdayUtcMorningSchedule != undefined ? nextProps.schedule.wednesdayUtcMorningSchedule.outTime : ""

				state.wednesdayEinTime = nextProps.schedule.wednesdayUtcEveningSchedule != undefined ? nextProps.schedule.wednesdayUtcEveningSchedule.inTime : ''
				state.wednesdayEoutTime = nextProps.schedule.mondayUtcEveningSchedule != undefined ? nextProps.schedule.wednesdayUtcEveningSchedule.outTime : ""


				if (
					nextProps.schedule.wednesdayMorningSchedule &&
					nextProps.schedule.wednesdayMorningSchedule.startMinute
				) {
					state.wednesdayMornStartMin =
						nextProps.schedule.wednesdayMorningSchedule.startMinute == "0"
							? "00"
							: state.wednesdayMornStartMin;


				}

				state.wednesdayMornEndHrs =
					nextProps.schedule.wednesdayMorningSchedule &&
						nextProps.schedule.wednesdayMorningSchedule.endHour
						? nextProps.schedule.wednesdayMorningSchedule.endHour
						: state.wednesdayMornEndHrs;

				if (
					nextProps.schedule.EveningSchedule &&
					nextProps.schedule.EveningSchedule.startMinute
				) {
					state.wednesdayMornEndMin =
						nextProps.schedule.EveningSchedule.startMinute == "0"
							? "00"
							: nextProps.schedule.EveningSchedule.startMinute;
				}
			}
		}
		// wednesday evening
		if (
			nextProps.schedule != undefined &&
			nextProps.schedule.hasOwnProperty("wednesdayEveningchedule") &&
			nextProps.schedule.wednesday == true
		) {
			if (nextProps.schedule && nextProps.schedule.wednesdayEveningchedule) {
				state.wednesdayEvenStartHrs =
					nextProps.schedule.wednesdayEveningchedule &&
						nextProps.schedule.wednesdayEveningchedule.startHour
						? nextProps.schedule.wednesdayEveningchedule.startHour
						: state.wednesdayEvenStartHrs;

				if (
					nextProps.schedule.wednesdayEveningchedule &&
					nextProps.schedule.wednesdayEveningchedule.startMinute
				) {
					state.wednesdayEvenStartMin =
						nextProps.schedule.wednesdayEveningchedule.startMinute == "0"
							? "00"
							: state.wednesdayEvenStartMin;
				}

				state.wednesdayEvenEndHrs =
					nextProps.schedule.wednesdayEveningchedule &&
						nextProps.schedule.wednesdayEveningchedule.endHour
						? nextProps.schedule.wednesdayEveningchedule.endHour
						: state.wednesdayEvenEndHrs;

				if (
					nextProps.schedule.wednesdayEveningchedule &&
					nextProps.schedule.wednesdayEveningchedule.startMinute
				) {
					state.wednesdayEvenEndMin =
						nextProps.schedule.wednesdayEveningchedule.startMinute == "0"
							? "00"
							: nextProps.schedule.wednesdayEveningchedule.startMinute;
				}
			}
		}


		//Thursday Morning
		if (
			nextProps.schedule != undefined &&
			nextProps.schedule.hasOwnProperty("thursdayMorningSchedule") &&
			nextProps.schedule.thursday == true
		) {
			if (nextProps.schedule && nextProps.schedule.thursdayMorningSchedule) {
				state.thursdayMornStartHrs =
					nextProps.schedule.thursdayMorningSchedule &&
						nextProps.schedule.thursdayMorningSchedule.startHour
						? nextProps.schedule.thursdayMorningSchedule.startHour
						: state.thursdayMornStartHrs;
				state.thursdayMinTime = nextProps.schedule.thursdayUtcMorningSchedule != undefined ? nextProps.schedule.thursdayUtcMorningSchedule.inTime : ''
				state.thursdayMoutTime = nextProps.schedule.thursdayUtcMorningSchedule != undefined ? nextProps.schedule.thursdayUtcMorningSchedule.outTime : ""

				state.thursdayEinTime = nextProps.schedule.thursdayUtcEveningSchedule != undefined ? nextProps.schedule.thursdayUtcEveningSchedule.inTime : ''
				state.thursdayEoutTime = nextProps.schedule.thursdayUtcEveningSchedule != undefined ? nextProps.schedule.thursdayUtcEveningSchedule.outTime : ""


				if (
					nextProps.schedule.thursdayMorningSchedule &&
					nextProps.schedule.thursdayMorningSchedule.startMinute
				) {
					state.thursdayMornStartMin =
						nextProps.schedule.thursdayMorningSchedule.startMinute == "0"
							? "00"
							: state.thursdayMornStartMin;



				}

				state.thursdayMornEndHrs =
					nextProps.schedule.thursdayMorningSchedule &&
						nextProps.schedule.thursdayMorningSchedule.endHour
						? nextProps.schedule.thursdayMorningSchedule.endHour
						: state.thursdayMornEndHrs;

				if (
					nextProps.schedule.EveningSchedule &&
					nextProps.schedule.EveningSchedule.startMinute
				) {
					state.thursdayMornEndMin =
						nextProps.schedule.EveningSchedule.startMinute == "0"
							? "00"
							: nextProps.schedule.EveningSchedule.startMinute;
				}
			}
		}


		//Thursday Evening
		if (
			nextProps.schedule != undefined &&
			nextProps.schedule.hasOwnProperty("thursdayEveningSchedule") &&
			nextProps.schedule.thursday == true
		) {
			if (nextProps.schedule && nextProps.schedule.thursdayEveningSchedule) {
				state.thursdayEvenStartHrs =
					nextProps.schedule.thursdayEveningSchedule &&
						nextProps.schedule.thursdayEveningSchedule.startHour
						? nextProps.schedule.thursdayEveningSchedule.startHour
						: state.thursdayEvenStartHrs;

				if (
					nextProps.schedule.thursdayEveningSchedule &&
					nextProps.schedule.thursdayEveningSchedule.startMinute
				) {
					state.thursdayEvenStartMin =
						nextProps.schedule.thursdayEveningSchedule.startMinute == "0"
							? "00"
							: state.thursdayEvenStartMin;
				}

				state.thursdayEvenEndHrs =
					nextProps.schedule.thursdayEveningSchedule &&
						nextProps.schedule.thursdayEveningSchedule.endHour
						? nextProps.schedule.thursdayEveningSchedule.endHour
						: state.thursdayEvenEndHrs;

				if (
					nextProps.schedule.thursdayEveningSchedule &&
					nextProps.schedule.thursdayEveningSchedule.startMinute
				) {
					state.thursdayEvenEndMin =
						nextProps.schedule.thursdayEveningSchedule.startMinute == "0"
							? "00"
							: nextProps.schedule.thursdayEveningSchedule.startMinute;
				}
			}
		}
		// Friday Morning
		if (
			nextProps.schedule != undefined &&
			nextProps.schedule.hasOwnProperty("fridayMorningSchedule") &&
			nextProps.schedule.friday == true
		) {
			if (nextProps.schedule && nextProps.schedule.fridayMorningSchedule) {
				state.fridayMornStartHrs =
					nextProps.schedule.fridayMorningSchedule &&
						nextProps.schedule.fridayMorningSchedule.startHour
						? nextProps.schedule.fridayMorningSchedule.startHour
						: state.fridayMornStartHrs;


				state.fridayMinTime = nextProps.schedule.fridayUtcMorningSchedule != undefined ? nextProps.schedule.fridayUtcMorningSchedule.inTime : ''
				state.fridayMoutTime = nextProps.schedule.fridayUtcMorningSchedule != undefined ? nextProps.schedule.fridayUtcMorningSchedule.outTime : ""

				state.fridayEinTime = nextProps.schedule.fridayUtcEveningSchedule != undefined ? nextProps.schedule.fridayUtcEveningSchedule.inTime : ''
				state.fridayEoutTime = nextProps.schedule.fridayUtcEveningSchedule != undefined ? nextProps.schedule.fridayUtcEveningSchedule.outTime : ""


				if (
					nextProps.schedule.fridayMorningSchedule &&
					nextProps.schedule.fridayMorningSchedule.startMinute
				) {
					state.fridayMornStartMin =
						nextProps.schedule.fridayMorningSchedule.startMinute == "0"
							? "00"
							: state.fridayMornStartMin;

				}

				state.fridayMornEndHrs =
					nextProps.schedule.fridayMorningSchedule &&
						nextProps.schedule.fridayMorningSchedule.endHour
						? nextProps.schedule.fridayMorningSchedule.endHour
						: state.fridayMornEndHrs;

				if (
					nextProps.schedule.EveningSchedule &&
					nextProps.schedule.EveningSchedule.startMinute
				) {
					state.fridayMornEndMin =
						nextProps.schedule.EveningSchedule.startMinute == "0"
							? "00"
							: nextProps.schedule.EveningSchedule.startMinute;
				}
			}
		}
		// Friday Evening
		if (
			nextProps.schedule != undefined &&
			nextProps.schedule.hasOwnProperty("fridayEveningSchedule") &&
			nextProps.schedule.friday == true
		) {
			if (nextProps.schedule && nextProps.schedule.fridayEveningSchedule) {
				state.fridayEvenStartHrs =
					nextProps.schedule.fridayEveningSchedule &&
						nextProps.schedule.fridayEveningSchedule.startHour
						? nextProps.schedule.fridayEveningSchedule.startHour
						: state.fridayEvenStartHrs;

				if (
					nextProps.schedule.fridayEveningSchedule &&
					nextProps.schedule.fridayEveningSchedule.startMinute
				) {
					state.fridayEvenStartMin =
						nextProps.schedule.fridayEveningSchedule.startMinute == "0"
							? "00"
							: state.fridayEvenStartMin;
				}

				state.fridayEvenEndHrs =
					nextProps.schedule.fridayEveningSchedule &&
						nextProps.schedule.fridayEveningSchedule.endHour
						? nextProps.schedule.fridayEveningSchedule.endHour
						: state.fridayEvenEndHrs;

				if (
					nextProps.schedule.fridayEveningSchedule &&
					nextProps.schedule.fridayEveningSchedule.startMinute
				) {
					state.fridayEvenEndMin =
						nextProps.schedule.fridayEveningSchedule.startMinute == "0"
							? "00"
							: nextProps.schedule.fridayEveningSchedule.startMinute;
				}
			}
		}
		// Saturday Morning
		if (
			nextProps.schedule != undefined &&
			nextProps.schedule.hasOwnProperty("saturdayMorningSchedule") &&
			nextProps.schedule.saturday == true
		) {
			if (nextProps.schedule && nextProps.schedule.saturdayMorningSchedule) {
				state.saturdayMornStartHrs =
					nextProps.schedule.saturdayMorningSchedule &&
						nextProps.schedule.saturdayMorningSchedule.startHour
						? nextProps.schedule.saturdayMorningSchedule.startHour
						: state.saturdayMornStartHrs;

				state.saturdayMinTime = nextProps.schedule.saturdayUtcMorningSchedule != undefined ? nextProps.schedule.saturdayUtcMorningSchedule.inTime : ''
				state.saturdayMoutTime = nextProps.schedule.saturdayUtcMorningSchedule != undefined ? nextProps.schedule.saturdayUtcMorningSchedule.outTime : ""

				state.saturdayEinTime = nextProps.schedule.saturdayUtcEveningSchedule != undefined ? nextProps.schedule.saturdayUtcEveningSchedule.inTime : ''
				state.saturdayEoutTime = nextProps.schedule.saturdayUtcEveningSchedule != undefined ? nextProps.schedule.saturdayUtcEveningSchedule.outTime : ""


				if (
					nextProps.schedule.saturdayMorningSchedule &&
					nextProps.schedule.saturdayMorningSchedule.startMinute
				) {
					state.saturdayMornStartMin =
						nextProps.schedule.saturdayMorningSchedule.startMinute == "0"
							? "00"
							: state.saturdayMornStartMin;

				}

				state.saturdayMornEndHrs =
					nextProps.schedule.saturdayMorningSchedule &&
						nextProps.schedule.saturdayMorningSchedule.endHour
						? nextProps.schedule.saturdayMorningSchedule.endHour
						: state.saturdayMornEndHrs;

				if (
					nextProps.schedule.EveningSchedule &&
					nextProps.schedule.EveningSchedule.startMinute
				) {
					state.saturdayMornEndMin =
						nextProps.schedule.EveningSchedule.startMinute == "0"
							? "00"
							: nextProps.schedule.EveningSchedule.startMinute;
				}
			}
		}
		// Saturday Evening
		if (
			nextProps.schedule != undefined &&
			nextProps.schedule.hasOwnProperty("saturdayEveningSchedule") &&
			nextProps.schedule.saturday == true
		) {
			if (nextProps.schedule && nextProps.schedule.saturdayEveningSchedule) {
				state.saturdayEvenStartHrs =
					nextProps.schedule.saturdayEveningSchedule &&
						nextProps.schedule.saturdayEveningSchedule.startHour
						? nextProps.schedule.saturdayEveningSchedule.startHour
						: state.saturdayEvenStartHrs;

				if (
					nextProps.schedule.saturdayEveningSchedule &&
					nextProps.schedule.saturdayEveningSchedule.startMinute
				) {
					state.saturdayEvenStartMin =
						nextProps.schedule.saturdayEveningSchedule.startMinute == "0"
							? "00"
							: state.saturdayEvenStartMin;


				}

				state.saturdayEvenEndHrs =
					nextProps.schedule.saturdayEveningSchedule &&
						nextProps.schedule.saturdayEveningSchedule.endHour
						? nextProps.schedule.saturdayEveningSchedule.endHour
						: state.saturdayEvenEndHrs;

				if (
					nextProps.schedule.saturdayEveningSchedule &&
					nextProps.schedule.saturdayEveningSchedule.startMinute
				) {
					state.saturdayEvenEndMin =
						nextProps.schedule.saturdayEveningSchedule.startMinute == "0"
							? "00"
							: nextProps.schedule.saturdayEveningSchedule.startMinute;
				}
			}
		}
		// Sunday Morning
		if (
			nextProps.schedule != undefined &&
			nextProps.schedule.hasOwnProperty("sundayMorningSchedule") &&
			nextProps.schedule.sunday == true
		) {
			if (nextProps.schedule && nextProps.schedule.sundayMorningSchedule) {
				state.sundayMornStartHrs =
					nextProps.schedule.sundayMorningSchedule &&
						nextProps.schedule.sundayMorningSchedule.startHour
						? nextProps.schedule.sundayMorningSchedule.startHour
						: state.sundayMornStartHrs;

				state.sundayMinTime = nextProps.schedule.sundayUtcMorningSchedule != undefined ? nextProps.schedule.sundayUtcMorningSchedule.inTime : ''
				state.sundayMoutTime = nextProps.schedule.sundayUtcMorningSchedule != undefined ? nextProps.schedule.sundayUtcMorningSchedule.outTime : ""

				state.sundayEinTime = nextProps.schedule.sundayUtcEveningSchedule != undefined ? nextProps.schedule.sundayUtcEveningSchedule.inTime : ''
				state.sundayEoutTime = nextProps.schedule.sundayUtcEveningSchedule != undefined ? nextProps.schedule.sundayUtcEveningSchedule.outTime : ""


				if (
					nextProps.schedule.sundayMorningSchedule &&
					nextProps.schedule.sundayMorningSchedule.startMinute
				) {
					state.sundayMornStartMin =
						nextProps.schedule.sundayMorningSchedule.startMinute == "0"
							? "00"
							: state.sundayMornStartMin;


				}

				state.sundayMornEndHrs =
					nextProps.schedule.sundayMorningSchedule &&
						nextProps.schedule.sundayMorningSchedule.startHour
						? nextProps.schedule.sundayMorningSchedule.startHour
						: state.sundayMornEndHrs;

				if (
					nextProps.schedule.EveningSchedule &&
					nextProps.schedule.EveningSchedule.startMinute
				) {
					state.sundayMornEndMin =
						nextProps.schedule.EveningSchedule.startMinute == "0"
							? "00"
							: nextProps.schedule.EveningSchedule.startMinute;
				}
			}
		}
		// SundayEvening
		if (
			nextProps.schedule != undefined &&
			nextProps.schedule.hasOwnProperty("sundayEveningSchedule") &&
			nextProps.schedule.sunday == true
		) {
			if (nextProps.schedule && nextProps.schedule.sundayEveningSchedule) {
				state.sundayEvenStartHrs =
					nextProps.schedule.sundayEveningSchedule &&
						nextProps.schedule.sundayEveningSchedule.startHour
						? nextProps.schedule.sundayEveningSchedule.startHour
						: state.sundayEvenStartHrs;

				if (
					nextProps.schedule.sundayEveningSchedule &&
					nextProps.schedule.sundayEveningSchedule.startMinute
				) {
					state.sundayEvenStartMin =
						nextProps.schedule.sundayEveningSchedule.startMinute == "0"
							? "00"
							: state.sundayEvenStartMin;
				}

				state.sundayEvenEndHrs =
					nextProps.schedule.sundayEveningSchedule &&
						nextProps.schedule.sundayEveningSchedule.endHour
						? nextProps.schedule.sundayEveningSchedule.endHour
						: state.sundayEvenEndHrs;

				if (
					nextProps.schedule.sundayEveningSchedule &&
					nextProps.schedule.sundayEveningSchedule.startMinute
				) {
					state.sundayEvenEndMin =
						nextProps.schedule.sundayEveningSchedule.startMinute == "0"
							? "00"
							: nextProps.schedule.sundayEveningSchedule.startMinute;
				}
			}
		}
		this.setState(state);
		console.log(state);
	}

	render() {
		var specialistDetails = this.state.specialistDetails;
		var specializationList = this.state.specializationList;
		var sel = this.state.specialization;
		var rows = [];
		var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
		var defaultImagePath = user.gender == 'Male' ? constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'doctor_m.png' : constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'doctor_f.png';

		if (user.image == constant.DEFAULT_USER_IMAGE) {
			var imagePath =
				user.gender == 'Male' ? constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'doctor_m.png' : constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'doctor_f.png';

		} else {
			var imagePath =
				constant.PRODUCTION_IMAGE_URL +
				constant.UPLOAD_FOLDER +
				localStorage.getItem("userId") +
				"/" +
				user.image;
		}
		{
			this.state.myFeedback
				? this.state.myFeedback.forEach(
					function (item, index) {
						var defaultPatientImagePath = item.userGender == 'Male' ? constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'patient_m.png' : constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'patient_f.png';

						var stars = [];
						for (var i = 0; i < Math.round(item.avgRate); i++) {
							stars.push(
								<Link id={i} className="reviewsStar startReview">
									<img
										className="rateStarSize"
										src={require("../../images/start_icon.png")}
									/>
								</Link>
							);
						}

						rows.push(
							<ul>
								<li>
									<div className="row">
										<div className="col-md-8 ">
											<div className="reviewsInfo patientReviews">
												<img
													className="appointment-list-img"
													src={
														defaultPatientImagePath
														// constant.PRODUCTION_IMAGE_URL +
														// "uploads/" +
														// item.patientId +
														// "/" +
														// item.patientDetail[0].profileImage
													}
													onError={e => {
														e.target.src = defaultPatientImagePath;
													}}
												/>
												{/* <h3>{this.Capitalize(item.encryptedUserName)} </h3> */}
												<h3>Verified User </h3>
												{stars}
											</div>
										</div>
										<div className="col-md-4 ">
											<div className="reviewsDate text-right">
												{" "}
												<Moment format="ll">{item.createdAt}</Moment>
											</div>
										</div>
										<div className="col-md-12 ">
											<p>{item.patientFeedback}</p>
										</div>{" "}
									</div>
								</li>
							</ul>
						);
					}.bind(this)
				)
				: "";
		}
		var questar = [];
		{
			this.state.questionRatings ? this.state.questionRatings.forEach(function (item, index) {
				var queRating = [];
				for (var i = 0; i < Math.round(item.avgRate); i++) {
					queRating.push(<a href="#" className="reviewsStarDd"><i className="fa fa-star "></i></a>)
				}
				for (var i = 0; i < (5 - Math.round(item.avgRate)); i++) {
					queRating.push(<a href="#" className="reviewsStarDd reviewsStarDdGray"><i className="fa fa-star "></i></a>)
				}
				questar.push(
					<li>{item.ratingqs}
						<p>	{queRating}</p>
					</li>


				)
			}.bind(this))
				: ""
		}
		return (
			<div>
				<ToastContainer />
				<div className="content-wrapper">
					<section className="content container-fluid">
						<div className="row">
							<div className="col-md-12">
								<div className="boxMrgB proCalendar">
									<div className="nav-tabs-custom">
										<ul className="nav nav-tabs">
											<li>
												<Link
													to="#tab_1"
													data-toggle="tab"
													className="active show"
												>
													Specialist Details
                        </Link>
											</li>
										</ul>
										<div className="row">


											<div className="col-md-12 col-lg-12 col-xl-12">
												<div className="tab-content tabother tspTab">
													<div className="row">
														<div className="col-md-12">
															<div className="searchBoxRes ">
																<div className="row">
																	<div className="col-md-12 col-lg-12 col-xl-5">
																		<div className="boxMrgB">
																			<div className="input-group inputBg">
																				{" "}
																				<span className="input-group-addon">
																					<i className="fa ">
																						<img
																							src={require("../../images/img/family_medicine.png")}
																							alt=""
																						/>
																					</i>
																				</span>

																				{this.state.specialization &&
																					this.state.specialization != "" ? (
																						<Typeahead
																							onChange={selected => {
																								console.log("selected", selected);
																								this.setState({
																									isReady: true,
																									specializationName:
																										selected &&
																											selected.length > 0
																											? selected[0].label
																											: "",
																									specialization:
																										selected &&
																											selected.length > 0
																											? selected[0].id
																											: ""
																								});
																							}}
																							options={specializationList}
																							defaultValue={
																								this.state.specialization
																							}
																							defaultSelected={[
																								{
																									id: this.state.specialization,
																									label: this.state
																										.specializationName
																								}
																							]}
																						//placeholder="Search Speciality"
																						/>
																					) : (
																						<Typeahead
																							onChange={selected => {
																								console.log("selected", selected);
																								this.setState({
																									isReady: true,
																									specializationName:
																										selected &&
																											selected.length > 0
																											? selected[0].label
																											: "",
																									specialization:
																										selected &&
																											selected.length > 0
																											? selected[0].id
																											: ""
																								});
																							}}
																							options={specializationList}
																							defaultValue={
																								this.state.specialization
																							}
																							//defaultSelected={[{ id: this.state.specialization, label: this.state.specializationName }]}
																							placeholder="Search Speciality"
																						/>
																					)}
																			</div>
																		</div>
																	</div>
																	<div className="col-md-12 col-lg-12 col-xl-5">
																		<div className="boxMrgB">
																			<div className="input-group inputBg">
																				{" "}
																				<span className="input-group-addon">
																					<i className="fa ">
																						<img
																							src={require("../../images/img/map_icon.png")}
																							alt=""
																						/>
																					</i>
																				</span>
																				{/* <input
																					type="text"
																					name="searchZipcode"
																					className="form-control"
																					onChange={this.onChange.bind(this)}
																					value={this.state.searchZipcode}
																					placeholder="Near city,Zipcode"

																				/> */}
																				<Autocomplete
																					id='autocomplete'
																					className="form-control cityinput"
																					data-toggle="tooltip"
																					data-placement="right"
																					title="Country, State and City will be automatically filled"
																					id="inputAddress2"
																					placeholder="Near City, Zip Code"
																					name="searchZipcode"
																					value={this.state.searchZipcode} onChange={this.onChange.bind(this)}
																					onPlaceSelected={this.updateAddress}
																					types={['(regions)']}
																				// autoComplete="off"
																				// {...fields}

																				/>
																			</div>
																		</div>
																	</div>
																	<div className="col-md-12 col-lg-12 col-xl-2">
																		<div className="boxMrgB">
																			<button
																				type="button"
																				onClick={this.search.bind(this)}
																				className="btn btn-block btn-warning btn-lg"
																				disabled={this.state.isSearch}
																			>
																				Search
                                      </button>
																		</div>
																	</div>
																</div>
																<div className="col-md-12" />
															</div>
															<div
																className="searchList  listings tspList searchAppList tabsearchdetail"
																style={{ marginTop: 63 }}
															>
																{specialistDetails.users ? (
																	<div className="searchImg">
																		{" "}
																		{specialistDetails.specialists &&
																			specialistDetails.specialists.length > 0 &&
																			specialistDetails.specialists[0]
																				.profileImage ==
																			constant.DEFAULT_USER_IMAGE ? (
																				<img
																					className="profile-user-img img-responsive img-circle"
																					src={
																						specialistDetails.users[0].gender == 'Male' ?
																							constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER +
																							constant.COMMON_FOLDER +
																							'doctor_m.png' :
																							constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER +
																							constant.COMMON_FOLDER +
																							'doctor_f.png'
																					}
																					alt="User profile picture"
																				/>
																			) : (
																				<img
																					className="profile-user-img img-responsive img-circle"
																					src={
																						constant.PRODUCTION_IMAGE_URL +
																						constant.UPLOAD_FOLDER +
																						specialistDetails.users[0]._id +
																						"/" +
																						specialistDetails.specialists[0]
																							.profileImage
																					}
																					alt="User profile picture"
																					onError={e => {
																						e.target.src = defaultImagePath;
																					}}
																				/>
																			)}
																		<div className="ribbonIcon">
																			<div className="btn-group">
																				<div className=" dropdown-toggle" style={{ 'cursor': 'pointer' }} onClick={this.rebbonClick}>
																					<img src={require('../../images/img/ribbon_icon.png')} />
																				</div>
																				<div className={this.state.rebbon ? "dropdown-menu show" : "dropdown-menu"}>
																					<Link onClick={this.rebbonClick.bind(this, 'close')} style={{ cursor: "pointer" }} className="closeBtn"></Link>

																					<Link className="dropdown-item" ><img src={require('../../images/img/ribbon_check.png')} /> Experience Summary
			</Link>
																					<Link className="dropdown-item" ><img src={require('../../images/img/ribbon_check.png')} /> Address
		</Link>
																					<Link className="dropdown-item" ><img src={require('../../images/img/ribbon_check.png')} /> Academics
		</Link>

																					<Link className="dropdown-item" ><img src={require('../../images/img/ribbon_check.png')} /> Identification </Link>
																					<Link className="dropdown-item" ><img src={require('../../images/img/ribbon_check.png')} /> Certifications  </Link>
																				</div>
																			</div>
																		</div>
																	</div>
																) : (
																		""
																	)}

																<div className="row">
																	<div className="col-md-12 col-sm-4 col-lg-4 tspBoxBrorder">
																		<h3 className="profile-username text-capitalize">
																			Dr.{" "}
																			{specialistDetails.users
																				? this.Capitalize(
																					specialistDetails.users[0].firstName
																				) +
																				" " +
																				this.Capitalize(
																					specialistDetails.users[0].lastName
																				)
																				: ""}
																		</h3>
																		<h4 className="profile-dr ">
																			{specialistDetails.specializations
																				? specialistDetails.specializations
																					.specialization
																				: ""}{" "}
																			{specialistDetails &&
																				specialistDetails.users
																				? "| " +
																				specialistDetails.users[0].gender
																				: ""}
																		</h4>
																		<div>
																			<h4 className="profile-dr">
																				{specialistDetails.specialists &&
																					specialistDetails.specialists.length
																					? specialistDetails.specialists[0]
																						.qualification
																					: ""}
																			</h4>
																			<div className="reviewsStarDd"><StarRatingComponent
																				name="rate2"
																				editing={false}
																				starCount={5}
																				emptyStarColor={'#D3D3D3'}
																				renderStarIcon={(index, value) => {
																					return (
																						<span>
																							{index <= value ? <span><img src={require('../../images/start_icon.png')} /></span> : <span><img src={require('../../images/start_icon_off.png')} /></span>}
																						</span>
																					);
																				}}
																				value={specialistDetails ? specialistDetails.averageRating : ''}
																			/>
																				<div className="btn-group show">
																					<Link style={{ 'cursor': 'pointer' }} onClick={this.reviewCount} className="reviewCount  dropdown-toggle reviewCountPosition" aria-haspopup="true" aria-expanded="false">
																						({specialistDetails ? specialistDetails.reviewCount : 0})</Link>
																					<div className={this.state.reviewCountClicked ? "dropdown-menu show " : "dropdown-menu "}>
																						<Link onClick={this.reviewCount} style={{ cursor: "pointer" }} className="closeBtn"></Link> <br />
																						<ul>

																							{questar.length > 0 ? questar
																								: <div className="text-center">No Feedback Yet</div>

																							}


																						</ul>
																					</div>
																				</div>
																			</div>
																		</div>
																		<p className="expInfo">
																			{specialistDetails.specialists &&
																				specialistDetails.specialists.length >
																				0 &&
																				specialistDetails.specialists[0]
																					.yearExperience}{" "}
																			year(s){" "}
																			{specialistDetails.specialists &&
																				specialistDetails.specialists.length >
																				0 &&
																				specialistDetails.specialists[0]
																					.monthExperience
																				? specialistDetails.specialists[0]
																					.monthExperience + " month(s)"
																				: ""}{" "}
																			experience
                                    </p>
																		<ul className="iconhirarchiaddrss">
																			<li className="font-icon-size">	<i className="fa fa-home" aria-hidden="true"></i></li>
																			<li>	{specialistDetails.clinicName}</li>
																		</ul>

																		<ul>
																			<li>
																				<i className="fa fa-map-marker" />
																			</li>
																			<li className="capitalized_txt">

																				<p>{specialistDetails.addressLineOne},</p>
																				<p>{specialistDetails.city},</p>
																				<p>{specialistDetails.state},</p>
																				<p>{specialistDetails.country},</p>
																				<p>{specialistDetails.zipCode}</p>

																				{/* <Link className="milesAway">3 miles away</Link> */}
																			</li>
																		</ul>
																		<Link>	{specialistDetails.mobileNo != null &&
																			specialistDetails.mobileNo != "" ? (
																				<p className="phoneInfo">
																					{" "}
																					<i className="fa fa-phone" />
																					{specialistDetails.mobileNo
																						? specialistDetails.phoneCode1
																						: ""}
																					- {specialistDetails.mobileNo}{" "}
																				</p>
																			) : (
																				""
																			)}</Link>
																		<Link>		{specialistDetails.telephoneNo != null &&
																			specialistDetails.telephoneNo != "" ? (
																				<p className="phoneInfo mobileIcon">
																					{" "}
																					{specialistDetails.telephoneNo ?
																						<i className="fa fa-mobile" />
																						: ''}{" "}
																					{specialistDetails.telephoneNo &&
																						specialistDetails.telephoneNo != null
																						? specialistDetails.phoneCode2
																						: ""}
																					- {specialistDetails.telephoneNo}{" "}
																				</p>
																			) : (
																				""
																			)}</Link>
																	</div>
																	<div className="col-md-12 col-sm-5 col-lg-5 tspBoxBrorder  mobile_specialist_details">
																		<div className="table-responsive">
																			<table
																				cellSpacing="0"
																				cellPadding="0"
																				className="consultationHr"
																				width="100%"
																			>
																				<tbody>
																					<tr>
																						<td
																							colSpan="3"
																							style={{ "text-align": "center" }}
																						>
																							Consultation Hours:
                                            </td>
																					</tr>
																					<tr>
																						<td width="25%">&nbsp;</td>
																						<td width="45%">
																							<img
																								src={require("../../images/img/sun_icon.png")}
																							/>
																						</td>
																						<td width="30%">
																							<img
																								src={require("../../images/img/moon_icon.png")}
																							/>
																						</td>
																					</tr>
																					<tr className="smallLineH">
																						<td>MON</td>
																						{this.state.schedule && this.state.schedule.hasOwnProperty('monday') && this.state.specialistDetails.mondayMorning == false ? <td><table><tr><td> {this.state.mondayMinTime ? moment.parseZone(new Date(this.state.mondayMinTime)).format('hh:mm A') : ''} </td><td>-</td> <td> {this.state.mondayMoutTime ? moment.parseZone(new Date(this.state.mondayMoutTime)).format('hh:mm A') + this.state.userlocation : ''} </td> <td></td></tr> </table></td> : <td>--</td>}
																						{this.state.schedule && this.state.schedule.hasOwnProperty('monday') && this.state.specialistDetails.mondayEvening == false ? <td><table><tr><td>{this.state.mondayEinTime ? moment.parseZone(new Date(this.state.mondayEinTime)).format('hh:mm A') : ''}</td><td>-</td> <td>{this.state.mondayEoutTime ? moment.parseZone(new Date(this.state.mondayEoutTime)).format('hh:mm A') + this.state.userlocation : ''}</td></tr> </table></td> : <td>--</td>}

																					</tr>
																					<tr className="smallLineH">
																						<td>TUE</td>
																						{this.state.schedule && this.state.schedule.hasOwnProperty('tuesday') && this.state.specialistDetails.tuesdayMorning == false ? <td><table><tr><td> {this.state.tuesdayMinTime ? moment.parseZone(new Date(this.state.tuesdayMinTime)).format('hh:mm A') : ''} </td><td>-</td> <td> {this.state.tuesdayMoutTime ? moment.parseZone(new Date(this.state.tuesdayMoutTime)).format('hh:mm A') + this.state.userlocation : ''} </td></tr> </table></td> : <td>--</td>}
																						{this.state.schedule && this.state.schedule.hasOwnProperty('tuesday') && this.state.specialistDetails.tuesdayEvening == false ? <td><table><tr><td>{this.state.tuesdayEinTime ? moment.parseZone(new Date(this.state.tuesdayEinTime)).format('hh:mm A') : ''}</td><td>-</td> <td>{this.state.tuesdayEoutTime ? moment.parseZone(new Date(this.state.tuesdayEoutTime)).format('hh:mm A') + this.state.userlocation : ''}</td></tr> </table></td> : <td>--</td>}

																					</tr>
																					<tr className="smallLineH">
																						<td>WED</td>
																						{this.state.schedule && this.state.schedule.hasOwnProperty('wednesday') && this.state.specialistDetails.wednesdayMorning == false ? <td><table><tr><td> {this.state.wednesdayMinTime ? moment.parseZone(new Date(this.state.wednesdayMinTime)).format('hh:mm A') : ''} </td><td>-</td> <td> {this.state.wednesdayMoutTime ? moment.parseZone(new Date(this.state.wednesdayMoutTime)).format('hh:mm A') + this.state.userlocation : ''}</td></tr> </table></td> : <td>--</td>}
																						{this.state.schedule && this.state.schedule.hasOwnProperty('wednesday') && this.state.specialistDetails.wednesdayEvening == false ? <td><table><tr><td>{this.state.wednesdayEinTime ? moment.parseZone(new Date(this.state.wednesdayEinTime)).format('hh:mm A') : ''} </td><td>-</td> <td>{this.state.wednesdayEoutTime ? moment.parseZone(new Date(this.state.wednesdayEoutTime)).format('hh:mm A') + this.state.userlocation : ''}</td></tr> </table></td> : <td>--</td>}

																					</tr>
																					<tr className="smallLineH">
																						<td>THU</td>
																						{this.state.schedule && this.state.schedule.hasOwnProperty('thursday') && this.state.specialistDetails.thursdayMorning == false ? <td><table><tr><td>{this.state.thursdayMinTime ? moment.parseZone(new Date(this.state.thursdayMinTime)).format('hh:mm A') : ''} </td><td>-</td> <td>{this.state.thursdayMoutTime ? moment.parseZone(new Date(this.state.thursdayMoutTime)).format('hh:mm A') + this.state.userlocation : ''}</td></tr> </table></td> : <td>--</td>}
																						{this.state.schedule && this.state.schedule.hasOwnProperty('thursday') && this.state.specialistDetails.thursdayEvening == false ? <td><table><tr><td>{this.state.thursdayEinTime ? moment.parseZone(new Date(this.state.thursdayEinTime)).format('hh:mm A') : ''} </td><td>-</td> <td>{this.state.thursdayEoutTime ? moment.parseZone(new Date(this.state.thursdayEoutTime)).format('hh:mm A') + this.state.userlocation : ''}</td></tr> </table></td> : <td>--</td>}

																					</tr>
																					<tr className="smallLineH">
																						<td>FRI</td>
																						{this.state.schedule && this.state.schedule.hasOwnProperty('friday') && this.state.specialistDetails.fridayMorning == false ? <td><table><tr><td>{this.state.fridayMinTime ? moment.parseZone(new Date(this.state.fridayMinTime)).format('hh:mm A') : ''} </td><td>-</td> <td>{this.state.fridayMoutTime ? moment.parseZone(new Date(this.state.fridayMoutTime)).format('hh:mm A') + this.state.userlocation : ''}</td></tr> </table></td> : <td>--</td>}
																						{this.state.schedule && this.state.schedule.hasOwnProperty('friday') && this.state.specialistDetails.fridayEvening == false ? <td><table><tr><td>{this.state.fridayEinTime ? moment.parseZone(new Date(this.state.fridayEinTime)).format('hh:mm A') : ''} </td><td>-</td> <td>{this.state.fridayEoutTime ? moment.parseZone(new Date(this.state.fridayEoutTime)).format('hh:mm A') + this.state.userlocation : ''}</td></tr> </table></td> : <td>--</td>}

																					</tr>
																					<tr className="smallLineH">
																						<td>SAT</td>
																						{this.state.schedule && this.state.schedule.hasOwnProperty('saturday') && this.state.specialistDetails.saturdayMorning == false ? <td><table><tr><td>{this.state.saturdayMinTime ? moment.parseZone(new Date(this.state.saturdayMinTime)).format('hh:mm A') : ''} </td><td>-</td> <td>{this.state.saturdayMoutTime ? moment.parseZone(new Date(this.state.saturdayMoutTime)).format('hh:mm A') + this.state.userlocation : ''}</td></tr> </table></td> : <td>--</td>}
																						{this.state.schedule && this.state.schedule.hasOwnProperty('saturday') && this.state.specialistDetails.saturdayEvening == false ? <td><table><tr><td>{this.state.saturdayEinTime ? moment.parseZone(new Date(this.state.saturdayEinTime)).format('hh:mm A') : ''} </td><td>-</td> <td>{this.state.saturdayEoutTime ? moment.parseZone(new Date(this.state.saturdayEoutTime)).format('hh:mm A') + this.state.userlocation : ''}</td></tr> </table></td> : <td>--</td>}

																					</tr>
																					<tr className="smallLineH">
																						<td>SUN</td>
																						{this.state.schedule && this.state.schedule.hasOwnProperty('sunday') && this.state.specialistDetails.sundayMorning == false ? <td><table><tr><td>{this.state.sundayMinTime ? moment.parseZone(new Date(this.state.sundayMinTime)).format('hh:mm A') : ''} </td><td>-</td> <td>{this.state.sundayMoutTime ? moment.parseZone(new Date(this.state.sundayMoutTime)).format('hh:mm A') + this.state.userlocation : ''}</td></tr> </table></td> : <td>--</td>}
																						{this.state.schedule && this.state.schedule.hasOwnProperty('sunday') && this.state.specialistDetails.sundayEvening == false ? <td><table><tr><td>{this.state.sundayEinTime ? moment.parseZone(new Date(this.state.sundayEinTime)).format('hh:mm A') : ''} </td><td>-</td> <td>{this.state.sundayEoutTime ? moment.parseZone(new Date(this.state.sundayEoutTime)).format('hh:mm A') + this.state.userlocation : ''}</td></tr> </table></td> : <td>--</td>}

																					</tr>
																				</tbody>
																			</table>
																		</div>
																		<br /><br /><br />
																		<p><b>Times displayed above are based on your location and may overlap into daytime or evening.</b></p>
																	</div>
																	{/* onClick={this.goToCalendarPage}  */}
																	<div className="col-md-12 col-sm-3 col-lg-3 ">
																		{specialistDetails.users ? (
																			<button
																				type="button"
																				className="btn btn-block btn-warning btn-sm requestApp requestAppmargintop"
																				onClick={this.showAddressPopUp.bind(
																					this,
																					specialistDetails.users[0]._id,
																					specialistDetails._id
																				)}
																			>
																				<i className=" fa-calendar-check-o fa" />
																				Request
                                        <br />
																				Appointment
                                      </button>
																		) : (
																				""
																			)}
																		<p className="consultationFeesLayout ">
																		<span><i className="fa">
																				<img
																					src={require("../../images/consultationfees_icon.png")}
																				/>
																			</i></span>
																			<div>Consultation Fees
                                      <span onClick={this.currencyApi.bind(this, this.state.specialistDetails.currencySymbol, this.state.specialistDetails.fee)}>
																				{this.state.specialistDetails.fee}{" "}
																				{
																					this.state.specialistDetails
																						.currencySymbol
																				}
																			</span>
																			</div>
																		</p>
																		<div className="col-sm-4 col-md-12 col-lg-12 dashboardDetailslanguageInfo">
																		<div className='row'>
																			<div className="col-sm-2"><i className="languageIcon"><img src={require('../../images/img/language_icon.jpg')} alt="" /></i>
																			</div>
																			<div className="col-md-auto">	<p className="expInfo">Languages Spoken</p>
																			</div>
																		</div>
																	</div>
																	<div className="col-sm-4 col-md-12 col-lg-12  languageList">
																		<p className="capitalized_txt languageTxt">Hindi, English, Bengali</p>
																	</div>
																	</div>
																</div>
																<div
																	className="popUpList popUpReq"
																	id="addressPopUp"
																>
																	<h5 className="heading-mediumfont">
																		{" "}
																		Select Address{" "}
																	</h5>
																	<Link
																		onClick={this.hideAddressPopUp}
																		className="closeBtn"
																	/>
																	<div className="popUpListInfo">
																		<ul>
																			{this.state.otherConsultationAddress
																				? this.state.otherConsultationAddress.map(
																					(item, index) => (
																						<div
																							key={
																								index
																							} /*style={{ marginTop: 25 }}*/
																						>
																							<li><i className="fa fa-home" aria-hidden="true"></i></li>
																							<li className="clinic-name-bold">{item.data.clinicName}</li>
																							<li>
																								{" "}
																								<i className="fa fa-map-marker" />
																							</li>
																							<li className="capitalized_txt">

																								<p>{item.data.addressLineOne},</p>
																								<p>{item.data.city},</p>
																								<p>{item.data.state},</p>
																								<p>{item.data.country},</p>
																								<p>{item.data.zipCode}</p>
																								<div className='miles-consultation-right'>
																									{this.state.otherMilesDistance && this.state.otherMilesDistance.length > 0 ? <Link style={{ color: "#00b5e8" }} >{this.state.otherMilesDistance[index].toFixed(2)} miles away</Link> : ''}

																								</div>
																							</li>
																							<li>
																								{" "}
																								{item.data.mobileNo
																									?
																									<i className="fa fa-phone" />
																									: ''}
																							</li>
																							<li className="phoneInfo">
																								<Link>{item.data.mobileNo
																									? item.data.phoneCode1 + '- '
																									: ""}
																									{item.data.mobileNo}</Link>
																							</li>
																							<li>
																								{" "}
																								{item.data.telephoneNo ?
																									<i className="fa fa-mobile" />
																									: ""}
																							</li>
																							<li className="phoneInfo">
																								<Link>
																									{item.data.telephoneNo &&
																										item.data.telephoneNo != null
																										? item.data.phoneCode2 + '- '
																										: ""}
																									{item.data.telephoneNo}
																								</Link>
																							</li>
																							<li>
																								{" "}
																								{item.data.telephoneNo ?
																									<p className="consultationFees " ><i className="fa"><img src={require('../../images/consultationfees_icon.png')} /></i></p>
																									: ""}
																							</li>
																							<li className="phoneInfo">
																								<p className="consultationFees " >Consultation Fees<span onClick={this.currencyApi.bind(this, item.data.currencySymbol, item.data.fee)}>{item.data.fee} {item.data.currencySymbol}</span></p>
																							</li>
																							<li className="wdtLi100">
																								<button
																									type="button"
																									className="btn btn-block btn-warning btn-sm requestApp"
																									onClick={this.goToCalendarPageFromOtherConsulatation.bind(
																										this,
																										item.data._id, index
																									)}
																								>
																									<i className=" fa-calendar-check-o fa" />
																									Request Appointment
                                                  </button>
																							</li>
																						</div>
																					)
																				)
																				: ""}
																		</ul>
																	</div>
																</div>
															</div>
														</div>
													</div>

													<div className="row">
														<div className="col-md-6 ">
															<div className="tspListBox limit300Words">
																<div className="tsbBlue">
																	<i className="fa">
																		<img
																			src={require("../../images/img/sub_specialities_icon.png")}
																		/>
																	</i>{" "}
																	Sub Specialities
                                </div>
																<div className="tsbGrayBox ">
																	{specialistDetails && specialistDetails.specialists && specialistDetails.specialists.length > 0 ? <span > {specialistDetails.specialists[0].subspecializationData} </span> : <p>No data has been added</p>}
																</div>
															</div>{" "}
														</div>
														<div className="col-md-6 ">
															<div className="tspListBox limit300Words">
																<div className="tsbBlue">
																	<i className="fa">
																		<img
																			src={require("../../images/img/academics.png")}
																		/>
																	</i>{" "}
																	Academics
                                </div>
																<div className="tsbGrayBox ">
																	{specialistDetails.specialists &&
																		specialistDetails.specialists[0] &&
																		specialistDetails.specialists[0].academics ? (
																			specialistDetails.specialists[0].academics
																		) : (
																			<p>No data has been added</p>
																		)}
																</div>
															</div>{" "}
														</div>
														<div className="col-md-12 ">
															<div className="tspListBox limit2000Words">
																<div className="tsbBlue">
																	<i className="fa">
																		<img
																			src={require("../../images/img/profile.png")}
																		/>
																	</i>{" "}
																	Profile
                                </div>
																<div className="tsbGrayBox ">
																	{specialistDetails.specialists &&
																		specialistDetails.specialists[0] &&
																		specialistDetails.specialists[0]
																			.profileSummary ? (
																			specialistDetails.specialists[0]
																				.profileSummary
																		) : (
																			<p>No data has been added</p>
																		)}
																</div>
															</div>{" "}
														</div>
														<div className="col-md-12 ">
															<div className="tspListBox">
																<div className="tsbBlue">
																	<i className="fa">
																		<img
																			src={require("../../images/img/pro_awards.png")}
																		/>
																	</i>{" "}
																	Professional Awards
                                </div>
																<div className="tsbGrayBox">
																	{specialistDetails.specialists &&
																		specialistDetails.specialists[0] &&
																		specialistDetails.specialists[0]
																			.professionalAward ? (
																			specialistDetails.specialists[0]
																				.professionalAward
																		) : (
																			<p>No data has been added</p>
																		)}
																</div>
															</div>{" "}
														</div>{" "}
													</div>
													<div className="row">
														<div className="col-md-12 ">
															<div className="userReviews" id="reviews">
																<h2>Patient Reviews / Feedbacks</h2>
																{rows.length > 0 ? rows : "No Feedback yet"}
															</div>
														</div>
													</div>
													{this.state.myFeedback &&
														this.state.myFeedback.length > 0 ? (
															<div className="row">
																<div className="col-sm-5">
																	<div className="showingEntries">
																		Showing{" "}
																		{this.state.activePage * this.state.count -
																			(this.state.count - 1)}{" "}
																		to{" "}
																		{this.state.activePage * this.state.count >
																			this.state.totalCount
																			? this.state.totalCount
																			: this.state.activePage *
																			this.state.count}{" "}
																		of {this.state.totalCount} entries
                                </div>
																</div>
																<div
																	className="col-sm-7 text-right"
																	style={{ cursor: "pointer" }}
																>
																	<Pagination
																		prevPageText="Prev"
																		nextPageText="Next"
																		hideFirstLastPages
																		activePage={this.state.activePage}
																		itemsCountPerPage={10}
																		totalItemsCount={this.state.totalCount}
																		pageRangeDisplayed={10}
																		onChange={this.handlePageChange.bind(this)}
																	/>
																</div>
															</div>
														) : (
															""
														)}
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</section>

					<div className="Copyrightafterlogin">
						<p>Medfix &copy; 2018. All rights reserved</p>

					</div>
				</div>
			</div>
		);
	}
}

//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
	return {
		specialistDetails: state.specialist.specialistDetails,
		otherConsultationAddress: state.specialist.otherConsultationAddress,
		specializationList: state.specialist.specializationList,
		myFeedback: state.specialist.myFeedback,
		schedule: state.specialist.specialistDetails && state.specialist.specialistDetails.doctorschedules,
		convertedCurrency: state.specialist.convertedCurrency,
		questionRatings: state.specialist.questionRatings

		// appointmentList: state.appointment.appointmentList
	};
}
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(specialistActions, dispatch),
		logoutAction: bindActionCreators(dashboardActions, dispatch)

	};
}
export default connect(
	mapStateToProps,
	mapDispatchToProps
)(SpecialistDetails);
